import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  PLATFORM_ID,
  SimpleChanges
} from '@angular/core';

type ConfirmButtonVariant = 'default' | 'danger';

@Component({
  selector: 'app-confirmation-dialog',
  standalone: false,
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss'
})
export class ConfirmationDialogComponent implements OnChanges, OnDestroy {
  @Input() open = false;
  @Input() title = 'Confirm Request';
  @Input() message = 'Are you sure you want to continue?';
  @Input() confirmText = 'Confirm';
  @Input() cancelText = 'Cancel';
  @Input() confirmVariant: ConfirmButtonVariant = 'danger';
  @Output() close = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<void>();

  private static nextTitleId = 0;
  readonly titleId = `confirmationDialogTitle${ConfirmationDialogComponent.nextTitleId++}`;
  private originalBodyOverflow = '';

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!('open' in changes) || !isPlatformBrowser(this.platformId)) return;

    const openChange = changes['open'];
    if (openChange.currentValue === true && openChange.previousValue !== true) {
      this.originalBodyOverflow = this.document.body.style.overflow;
      this.document.body.style.overflow = 'hidden';
      return;
    }

    if (openChange.currentValue === false && openChange.previousValue === true) {
      this.restoreBodyOverflow();
    }
  }

  ngOnDestroy(): void {
    this.restoreBodyOverflow();
  }

  @HostListener('document:keydown.escape')
  onEscapeKeyDown(): void {
    if (!this.open) {
      return;
    }
    this.onClose();
  }

  onClose(): void {
    this.close.emit();
  }

  onConfirm(): void {
    this.confirm.emit();
  }

  private restoreBodyOverflow(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    this.document.body.style.overflow = this.originalBodyOverflow;
  }
}
